import { Access } from "../pages/admin-panel/users/types";
import { ChequeStatus } from "../types";

export const chequeStatusToString = (status: ChequeStatus): string => {
  switch (status) {
    case "confirmed":
      return "تایید شده";
    case "delivered":
      return "تحویل مدیر";
    case "received":
      return "دریافت شده";
    case "spent":
      return "خرج شده";
    default:
      return "unknown cheque status!";
  }
};

export const getNextChequeStatus = (
  status: ChequeStatus
): ChequeStatus | null => {
  switch (status) {
    case "received":
      return "confirmed";
    case "confirmed":
      return "delivered";
    case "delivered":
      return "spent";
    case "spent":
      return null;
    default:
      return null;
  }
};

export const getAccessForChequeStatus = (status: ChequeStatus): Access => {
  switch (status) {
    case "confirmed":
      return "ConfirmCheque";
    case "delivered":
      return "DeliverCheque";
    case "received":
      return "ReceiveCheque";
    case "spent":
      return "SpendCheque";
    default:
      return "Admin";
  }
};
